import { type } from "arktype";

export const ForceRefreshSchema = type("boolean").default(false);
